import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendEmail } from '../../store/actions/shareButtons';
import Button from '../buttons/Button';
import { ToastContainer, toast } from 'react-toastify';

function Notify() {
  toast.error('Wpisz poprawny adres email.', {
    closeOnClick: true,
    position: 'top-right',
    autoClose: 10000,
    toastId: 1, // show only one
  });
}
class ShareSendEmailPopUpContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
    };

    this.handleEmailSubmit = this.handleEmailSubmit.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }

  handleEmailSubmit = async e => {
    e.preventDefault();

    const pattern = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/);
    const checkEmail = pattern.test(this.state.email);

    const openDoor = await this.props.imageOpen();
    const closeDoor = await this.props.imageClose();
    const prices = this.props.prices();

    if (checkEmail) {
      this.props.sendEmail({
        email: this.state.email,
        imageOpen: openDoor,
        imageClose: closeDoor,
        prices: prices,
      });
      this.props.setSended();
    } else {
      Notify();
    }
  };

  handleEmailChange = event => {
    this.setState({
      email: event.target.value,
    });
  };

  render() {
    return (
      <form onSubmit={this.handleEmailSubmit} method="post">
        <div className="pop-up__content">
          <div className="pop-up__content-item">
            {this.props.sended && (
              <div
                className={`share_message share_message${
                  this.props.messageEmailError ? '__error' : '__success'
                }`}>
                {this.props.messageEmailError
                  ? this.props.messageEmailError
                  : this.props.messageEmail}
              </div>
            )}
            <div>
              <p>Adres email:</p>
              <input
                type="text"
                className="share_input"
                name="email"
                value={this.state.email}
                onChange={this.handleEmailChange}
              />
            </div>
            <div className="pop-up__buttons">
              <Button text="Wyślij" />
            </div>
          </div>
        </div>
        <ToastContainer />
      </form>
    );
  }
}

ShareSendEmailPopUpContent.propTypes = {
  imageOpen: PropTypes.func.isRequired,
  imageClose: PropTypes.func.isRequired,
  sendEmail: PropTypes.func.isRequired,
  prices: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    token: state.token.token,
    messageEmail: state.socialShare.messageEmail,
    messageEmailError: state.socialShare.messageEmailError,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    sendEmail: formData => dispatch(sendEmail(formData, ownProps.token)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareSendEmailPopUpContent);
